export const DEFAULT_AVATAR_ID = 'default' as const;
export const PAGE_HEADER_MAX_HEIGHT = 50;
